import React, { createContext, useContext, useRef, useState } from 'react';
import { getPodcastForToday } from '../service/home';
import { trackCTA } from '../service/usercta';

const PodcastContext = createContext(null);

export const usePodcast = () => useContext(PodcastContext);

export const PodcastProvider = ({ children }) => {
    const [isPodcastOpen, setIsPodcastOpen] = useState(false);
    const [podcast, setPodcast] = useState(null);
    const [podcastPlayedMs, setPodcastPlayedMs] = useState(0);

    const podcastPlayedAccRef = useRef(0);
    const lastAudioTimeRef = useRef(null);
    const lastUpdateSecRef = useRef(0);

    const handleListenNow = async () => {
        setIsPodcastOpen(true);
        try {
            const data = await getPodcastForToday();
            setPodcast(data);
        } catch (err) {
            console.error('Failed to load podcast:', err);
        }
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            trackCTA('podcast', user, window.location.pathname);
        } catch (trackErr) {
            console.error('trackCTA failed:', trackErr);
        }
    };

    const handleAudioTimeUpdate = (ct) => {
        if (lastAudioTimeRef.current !== null) {
            const delta = ct - lastAudioTimeRef.current;
            if (delta > 0 && delta < 1) {
                podcastPlayedAccRef.current += delta;
                const currentSec = Math.floor(podcastPlayedAccRef.current);
                if (currentSec > lastUpdateSecRef.current) {
                    lastUpdateSecRef.current = currentSec;
                    setPodcastPlayedMs(Math.floor(podcastPlayedAccRef.current * 1000));
                }
            }
        }
        lastAudioTimeRef.current = ct;
    };

    const handleClose = () => {
        setIsPodcastOpen(false);
        lastAudioTimeRef.current = null;
    };

    return (
        <PodcastContext.Provider value={{
            isPodcastOpen,
            podcast,
            podcastPlayedMs,
            handleListenNow,
            handleAudioTimeUpdate,
            handleClose,
        }}>
            {children}
        </PodcastContext.Provider>
    );
};
